module.exports = __webpack_public_path__ + "static/media/bwSpeech.c6e29709.jpg";